var React = require('react');

function YoutubeIconInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Deviant Robot YouTube"),React.createElement("path",{"d":"M147.443 16.142a18.795 18.795 0 0 0-13.261-13.277C122.483-.274 75.578-.274 75.578-.274s-46.906 0-58.605 3.139A18.796 18.796 0 0 0 3.712 16.142C.578 27.854.578 52.292.578 52.292s0 24.437 3.134 36.148c1.725 6.462 6.808 11.552 13.261 13.279 11.699 3.137 58.605 3.137 58.605 3.137s46.905 0 58.604-3.137c6.454-1.727 11.536-6.817 13.261-13.279 3.135-11.711 3.135-36.148 3.135-36.148s0-24.438-3.135-36.15zM60.577 74.82l38.97-22.528-38.97-22.529V74.82z","key":1})]);
}

YoutubeIconInline.defaultProps = {"fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"1.414","clipRule":"evenodd","viewBox":"0 0 151 106"};

module.exports = YoutubeIconInline;

YoutubeIconInline.default = YoutubeIconInline;
